<template>
  <div class="modal fade" id="fileViewerModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg w-95 mw-95 mb-0">
      <div
        :class="`modal-content vh-95 bg-${getColorMode.background} text-${getColorMode.text}`"
        v-if="selectedVersion"
      >
        <div
          :class="`modal-header bg-${getColorMode.globalBackground} text-${getColorMode.text} border-0 shadow-sm`"
        >
          <h3 class="modal-title">
            <span class="text-muted fs-4">Visor archivo </span>
            <span class="fw-bolder">{{ selectedVersion.name }} </span>
            <small class="text-muted fw-normal fs-5">
              v{{ selectedVersion.version }}</small
            >
          </h3>
          <button
            type="button"
            class="btn-close text-white"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body p-0">
          <div class="container-fluid h-100 py-0" style="padding: 12px">
            <div class="row h-100">
              <div
                :class="`col text-center img-container d-flex justify-content-center align-items-center p-0`"
              >
                <img
                  v-if="
                    selectedVersion.extension.match(
                      /^(jpg|png|jpeg|gif|tiff|raw)$/
                    )
                  "
                  :src="`${getDoc(selectedVersion)}`"
                  :class="`img-file-viewer`"
                />
                <iframe
                  v-else
                  :src="`${getDoc(selectedVersion)}`"
                  class="h-100 w-100 text-center overflow-hidden"
                  id="file-viewer"
                />
              </div>
              <div class="col-12 col-md-3 p-4" v-if="showDetails">
                <h4 class="file-view-title">Visualización archivo</h4>
                <div class="row mt-3">
                  <div class="col-12 d-flex flex-column">
                    <p class="file-view-item">
                      Nombre:
                      <span class="file-view-item-name">{{
                        selectedVersion.id
                          ? selectedVersion.name
                          : "Cargar archivo"
                      }}</span>
                    </p>
                    <p class="file-view-item">
                      Versión:
                      <span class="file-view-item-name">{{
                        selectedVersion.version
                      }}</span>
                    </p>
                    <p class="file-view-item">
                      Fecha de carga:
                      <span class="file-view-item-name">{{
                        formatUploadDate(selectedVersion.created_at)
                      }}</span>
                    </p>
                    <p class="file-view-item">
                      Extensión:
                      <span class="file-view-item-name">{{
                        selectedVersion.extension
                      }}</span>
                    </p>
                    <p class="file-view-item">
                      Ubicación:
                      <span class="file-view-item-name">{{
                        folder && folder[0].complete_name
                          ? folder[0].complete_name
                          : "Cargando..."
                      }}</span>
                    </p>
                  </div>
                </div>
                <div v-if="hasScans">
                  <label class="fw-bold">MD5</label>
                  <div class="text-end">{{ selectedVersion.scans[0].md5 }}</div>
                </div>
                <div class="my-4">
                  <div class="btn-group w-100" role="group">
                    <Popper
                      class="btn btn-primary m-0 border-0"
                      content="Comentarios"
                      placement="top"
                      hover
                      arrow
                      @click="modalFileComment = true"
                    >
                      <font-awesome-icon :icon="['fas', 'comments']" />
                    </Popper>
                    <a
                      class="btn btn-primary <"
                      :href="selectedVersion.url"
                      target="_blank"
                    >
                      <Popper
                        class="m-0 border-0"
                        content="Descargar"
                        placement="top"
                        hover
                        arrow
                      >
                        <font-awesome-icon
                          :icon="['fas', 'cloud-arrow-down']"
                        />
                      </Popper>
                    </a>
                    <Popper
                      class="btn btn-primary m-0 border-0"
                      content="Compartir"
                      placement="top"
                      hover
                      arrow
                      @click="modalFileShare = true"
                    >
                      <font-awesome-icon :icon="['fas', 'share']" />
                    </Popper>
                    <Popper
                      class="btn btn-primary m-0 border-0"
                      content="Transformar"
                      placement="top"
                      hover
                      arrow
                      @click="modalFileConversion = true"
                    >
                      <font-awesome-icon :icon="['fas', 'icons']" />
                    </Popper>
                  </div>
                </div>
                <ul
                  :class="`nav nav-tabs nav-tabs-${getColorMode.background}`"
                  id="myTab"
                  role="tablist"
                >
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link active"
                      id="folders-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#folders"
                      type="button"
                      role="tab"
                      aria-controls="folders"
                      aria-selected="true"
                    >
                      Carpeta
                    </button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link"
                      id="versions-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#versions"
                      type="button"
                      role="tab"
                      aria-controls="versions"
                      aria-selected="false"
                    >
                      Versiones
                    </button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link"
                      id="conversion-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#conversions"
                      type="button"
                      role="tab"
                      aria-controls="conversions"
                      aria-selected="false"
                    >
                      Conversiones
                    </button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link"
                      id="conversion-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#security"
                      type="button"
                      role="tab"
                      aria-controls="security"
                      aria-selected="false"
                    >
                      Seguridad
                    </button>
                  </li>
                </ul>
                <div class="tab-content" id="myTabContent">
                  <div
                    class="tab-pane fade show active"
                    id="folders"
                    role="tabpanel"
                    aria-labelledby="folders-tab"
                  >
                    <template v-if="folder">
                      <table
                        :class="`table table-${getColorMode.background} fs-small table-condensed`"
                      >
                        <thead>
                          <tr>
                            <th colspan="2" scope="col" class="text-center h6">
                              Archivos de la carpeta {{ folder.name }}
                            </th>
                          </tr>
                          <tr>
                            <th scope="col">Nombre</th>
                            <th scope="col">Ver</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(file, key) in folder.files"
                            :key="`file${file.id}${key}`"
                          >
                            <td class="align-middle">{{ file.name }}</td>
                            <td class="align-middle">
                              <Popper
                                class="btn btn-primary btn-sm px-3 m-0 border-0"
                                content="Ver"
                                placement="top"
                                hover
                                arrow
                                @click="setData(file.id)"
                              >
                                <font-awesome-icon :icon="['fas', 'eye']" />
                              </Popper>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </template>
                  </div>
                  <div
                    class="tab-pane fade"
                    id="versions"
                    role="tabpanel"
                    aria-labelledby="versions-tab"
                  >
                    <table
                      :class="`table table-${getColorMode.background} fs-small mb-0 table-condensed`"
                    >
                      <thead>
                        <tr>
                          <th colspan="2" scope="col" class="text-center h6">
                            Versiones
                          </th>
                        </tr>
                        <tr>
                          <th scope="col">Versión</th>
                          <th scope="col">Ver</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="version in versions"
                          v-bind:key="version.id"
                          :class="{
                            'bg-light': version.id == selectedVersion.id,
                          }"
                        >
                          <td class="align-middle">
                            {{ version.version
                            }}<span v-if="version.id == versions[0].id">*</span>
                          </td>
                          <td class="align-middle">
                            <Popper
                              class="btn btn-primary btn-sm px-3 m-0 border-0"
                              content="Ver"
                              placement="top"
                              hover
                              arrow
                              @click="selectedVersion = version"
                            >
                              <font-awesome-icon :icon="['fas', 'eye']" />
                            </Popper>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <small class="text-muted fst-italic fs-small fw-bold"
                      >*Versión actual</small
                    >
                  </div>
                  <div
                    class="tab-pane fade show"
                    id="conversions"
                    role="tabpanel"
                    aria-labelledby="folders-tab"
                  >
                    <table
                      v-if="hasConversions"
                      :class="`table table-${getColorMode.background} fs-small mb-0 table-condensed`"
                    >
                      <thead>
                        <tr>
                          <th colspan="2" scope="col" class="text-center h6">
                            Conversiones
                          </th>
                        </tr>
                        <tr>
                          <th scope="col">Extensión</th>
                          <th scope="col">Ver</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="conversion in selectedVersion.conversions"
                          v-bind:key="conversion.id"
                        >
                          <td class="align-middle">
                            {{ conversion.extension }}
                          </td>
                          <td class="align-middle">
                            <a
                              class="btn btn-primary <"
                              :href="conversion.url"
                              target="_blank"
                            >
                              <Popper
                                class="m-0 border-0"
                                content="Descargar"
                                placement="top"
                                hover
                                arrow
                              >
                                <font-awesome-icon
                                  :icon="['fas', 'cloud-arrow-down']"
                                />
                              </Popper>
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div v-else>
                      <p class="text-center text-muted m-5">
                        No hay conversiones para esta versión ;)
                      </p>
                    </div>
                  </div>
                  <div
                    class="tab-pane fade show"
                    id="security"
                    role="tabpanel"
                    aria-labelledby="folders-tab"
                  >
                    <div v-if="hasScans">
                      <table
                        v-for="scan in selectedVersion.scans"
                        v-bind:key="scan.id"
                        :class="`table table-${getColorMode.background} fs-small mb-0 table-condensed`"
                      >
                        <tbody>
                          <tr>
                            <td class="align-middle">Inofensivo</td>
                            <td class="align-middle">{{ scan.harmless }}</td>
                          </tr>
                          <tr>
                            <td class="align-middle">Malicioso</td>
                            <td class="align-middle">{{ scan.malicious }}</td>
                          </tr>
                          <tr>
                            <td class="align-middle">MD5</td>
                            <td class="align-middle">{{ scan.md5 }}</td>
                          </tr>
                          <tr>
                            <td class="align-middle">Sha256</td>
                            <td class="align-middle">{{ scan.sha256 }}</td>
                          </tr>
                          <tr>
                            <td class="align-middle">Sha1</td>
                            <td class="align-middle">{{ scan.sha1 }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div v-else>
                      <p class="text-center text-muted m-5">
                        No hay escaneos para esta versión
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <FileConversion
    @close-modal="modalFileConversion = false"
    :projectId="projectId"
    :fileId="selectedVersion.id"
    :folderId="folderId"
    v-if="modalFileConversion"
  />
  <FileShare
    @close-modal="modalFileShare = false"
    :projectId="projectId"
    :fileId="selectedVersion.id"
    :folderId="folderId"
    v-if="modalFileShare"
  />
  <FileComment
    @close-modal="modalFileComment = false"
    :projectId="projectId"
    :fileId="selectedVersion.id"
    :folderId="folderId"
    v-if="modalFileComment"
    :file-name="selectedVersion.name"
  />
</template>
<script>
import FileShare from "@/components/FileShare.vue";
import FileComment from "@/components/FileComments.vue";
import FileConversion from "@/components/FileConversion.vue";
import { Modal } from "bootstrap";
import { mapGetters } from "vuex";
export default {
  name: "FileViewer",
  emits: ["closeModal"],
  components: { FileShare, FileComment, FileConversion },
  props: {
    projectId: { type: Number, default: 0 },
    folderId: { type: Number, default: 0 },
    fileId: { type: Number, default: 0 },
    folderFileId: { type: Number, default: 0 },
    showDetails: { type: Boolean, default: false },
  },
  data() {
    return {
      modal: null,
      modalFileShare: false,
      modalFileComment: false,
      modalFileConversion: false,
      selectedVersion: null,
      versions: [],
      folder: null,
    };
  },
  mounted() {
    let app = this;
    this.axios
      .get(
        `projects/${this.projectId}/folders/${this.folderId}/files/${this.fileId}/versions`
      )
      .then((result) => {
        app.modal = new Modal(document.getElementById("fileViewerModal"), {});
        app.modal.show();
        app.versions = result.data.body;
        app.selectedVersion = app.versions[0];
        document
          .getElementById("fileViewerModal")
          .addEventListener("hide.bs.modal", function () {
            app.$emit("closeModal");
          });
      })
      .catch((error) => {
        console.log(error);
      });
    this.axios
      .get(`projects/${this.projectId}/folders/${this.folderId}`)
      .then((result) => {
        app.folder = result.data.body;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  methods: {
    formatUploadDate(uploadDate) {
      const dateObject = new Date(uploadDate);
      return `${dateObject.getUTCDate()}-${
        dateObject.getUTCMonth() + 1
      }-${dateObject.getUTCFullYear()} ${String(
        dateObject.getUTCHours()
      ).padStart(2, "0")}:${String(dateObject.getUTCMinutes()).padStart(
        2,
        "0"
      )}`;
    },
    setData(fileId) {
      let app = this;
      this.axios
        .get(
          `projects/${this.projectId}/folders/${this.folderId}/files/${fileId}/versions`
        )
        .then((result) => {
          app.versions = result.data.body;
          app.selectedVersion = app.versions[0];
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getDoc(file) {
      if (file.conversions) {
        let converterd = file.conversions.find(
          (conversion) => conversion.web == true
        );
        return converterd ? converterd.url : file.url;
      } else {
        return file.url;
      }
    },
  },
  computed: {
    ...mapGetters("general", ["getColorMode"]),
    hasConversions() {
      return this.selectedVersion.conversions
        ? this.selectedVersion.conversions.length > 0
        : false;
    },
    hasScans() {
      return this.selectedVersion.scans
        ? this.selectedVersion.scans.length > 0
        : false;
    },
  },
};
</script>
